module.exports = __webpack_public_path__ + "img/full.67817097.png";